import React, { useEffect, useState } from 'react';
import { usePortalContainer } from "@/common/hooks/use-portal-container";
import { Input } from "@/components/ui/input";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

interface Props {
    handleChangeValueField: (value: string) => void;
    valueField?: string | null;
}

const FilterRowValueFieldSpecialDateComponent: React.FC<Props> = ({
    handleChangeValueField,
    valueField
}) => {
    const portalContainer = usePortalContainer();
    const initialDateNumberValue = (valueField && !Array.isArray(valueField) && !valueField.includes('isbetween')) ? valueField.split('-')[0] : ''
    const initialDatePeriodValue = (valueField && !Array.isArray(valueField) && !valueField.includes('isbetween')) ? valueField.split('-')[1] : 'days'
    const [specialDateNumberValue, setSpecialDateNumberValue] = useState<string>(initialDateNumberValue);
    const [specialDatePeriodValue, setSpecialDatePeriodValue] = useState<string>(initialDatePeriodValue);

    // TIME PERIOD EDIT
    useEffect(() => {
        if (valueField && !Array.isArray(valueField) && !valueField.includes('isbetween')) {
            const specialDateNumber = valueField.split('-')[0]
            const specialDatePeriod = valueField.split('-')[1]
            setSpecialDateNumberValue(specialDateNumber)
            setSpecialDatePeriodValue(specialDatePeriod || 'days')
        }
    }, [valueField]);

    const handleNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value;
        setSpecialDateNumberValue(val);
        handleChangeValueField(val + '-' + (specialDatePeriodValue || 'days'))
    };

    const handlePeriodChange = (val: string) => {
        setSpecialDatePeriodValue(val);
        handleChangeValueField(specialDateNumberValue + '-' + val);
    };

    return (
        <div className="grid grid-cols-[80px_120px] gap-1.5 items-center">
            <Input
                type='number'
                value={specialDateNumberValue ?? ''}
                onChange={handleNumberChange}
                className="h-9 text-sm"
                placeholder="0"
            />
            <Select
                value={specialDatePeriodValue}
                onValueChange={handlePeriodChange}
            >
                <SelectTrigger className="h-9 text-sm">
                    <SelectValue placeholder="Period" />
                </SelectTrigger>
                <SelectContent container={portalContainer}>
                    <SelectItem value="days">Days</SelectItem>
                    <SelectItem value="weeks">Weeks</SelectItem>
                    <SelectItem value="months">Months</SelectItem>
                </SelectContent>
            </Select>
        </div>
    );
}

export default FilterRowValueFieldSpecialDateComponent;
